/* eslint-disable */

import * as customerManagementService from "../../../services/customer";
import * as settings from "../../../services/settings";
import * as warehouseManagementService from "../../../services/warehouse";

import { Button, Col, Form, Modal, Select, Spin, notification } from "antd";
import React, { useCallback, useEffect, useState } from "react";

import { useAccessToken } from "../../../contexts/AccessTokenContext";

const initPage = { limit: 0, page: 1 };

export const ModalCreateRoute = ({
  t,
  handleOk,
  handleCancel,
  fetchCustomerRoutes,
  editCustomerRoutesData,
  customerRoutesData,
  isModalOpen,
  setIsModalOpen,
  isEdit,
  detailData,
  onRoutesMutated,
}) => {
  const { accessToken } = useAccessToken();
  const [formCustomerRoutes] = Form.useForm();
  const [routeLoading, setRouteLoading] = useState(false);
  const [destination, setDestination] = useState([]);
  const [origin, setOrigin] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [search, setSearch] = useState(initPage);
  const [destinationName, setDestinationName] = useState("");
  const [originName, setOriginName] = useState("");

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onSubmitRoutes = async () => {
    try {
      await formCustomerRoutes.validateFields();
    } catch {
      return;
    }

    const values = formCustomerRoutes.getFieldsValue();
    const { origin, destination } = values || {};
    const prepareDataCustomerRoutes = {
      destination_id: destination,
      origin_id: origin,
      old_origin_id: isEdit ? editCustomerRoutesData.origin_id : null,
      old_destination_id: isEdit ? editCustomerRoutesData.destination_id : null,
      origin_name: originName,
      destination_name: destinationName,
      company_code: detailData.app_company.company_code,
      customer_code: detailData.customer_code,
      old_origin_name: isEdit
        ? editCustomerRoutesData.app_warehouse_app_customerroute_origin_idToapp_warehouse.warehouse_code
        : null,
      old_destination_name: isEdit
        ? editCustomerRoutesData.app_warehouse_app_customerroute_destination_idToapp_warehouse.warehouse_code
        : null,
    };
    const updateCustomerRoutesData = {
      customer_id: detailData.id,
      ...prepareDataCustomerRoutes,
    };

    setRouteLoading(true);
    try {
      if (isEdit) {
        if (typeof origin === "string") {
          updateCustomerRoutesData.origin_id = editCustomerRoutesData.origin_id;
        }
        if (typeof destination === "string") {
          updateCustomerRoutesData.destination_id = editCustomerRoutesData.destination_id;
        }
        const responseData = await customerManagementService.updateCustomerRoutes(
          accessToken,
          editCustomerRoutesData.id,
          updateCustomerRoutesData
        );

        if (responseData != undefined) {
          openNotificationWithIcon(
            settings.NotificationType.SUCCESS,
            <>{"Success."}</>,
            <>{"Update routes Success"}</>
          );
        }
      } else {
        const responseData = await customerManagementService.createCustomerRoutes(
          accessToken,
          detailData.id,
          prepareDataCustomerRoutes
        );

        if (responseData != undefined) {
          openNotificationWithIcon(
            settings.NotificationType.SUCCESS,
            <>{"Success."}</>,
            <>{"Create routes Success"}</>
          );
        }
      }
      await fetchCustomerRoutes();
      onRoutesMutated?.();
      setIsModalOpen(false);
      formCustomerRoutes.resetFields();
    } catch (err) {
      console.error("[ModalCreateRoute] onSubmitRoutes: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    } finally {
      setRouteLoading(false);
    }
  };

  const originRules = [
    {
      required: true,
      message: t("Customer_Create.Create_Route.Validation_Origin_Required"),
    },
    ...(!isEdit
      ? [
          {
            validator: async (_, value) => {
              const n = Number(value);
              if (!Number.isFinite(n) || !Number.isInteger(n) || n < 1) {
                return Promise.reject(
                  new Error(t("Customer_Create.Create_Route.Validation_Warehouse_Id_Invalid"))
                );
              }
              return Promise.resolve();
            },
          },
        ]
      : []),
  ];

  const destinationRules = [
    {
      required: true,
      message: t("Customer_Create.Create_Route.Validation_Destination_Required"),
    },
    ...(!isEdit
      ? [
          {
            validator: async (_, value) => {
              const n = Number(value);
              if (!Number.isFinite(n) || !Number.isInteger(n) || n < 1) {
                return Promise.reject(
                  new Error(t("Customer_Create.Create_Route.Validation_Warehouse_Id_Invalid"))
                );
              }
              return Promise.resolve();
            },
          },
        ]
      : []),
  ];

  const fetchCompanyWareHouseRoutes = useCallback(async (param) => {
    setRouteLoading(true);
    let resDestination = [];
    let resOrigin = [];
    try {
      const data = await warehouseManagementService.getWarehouses(accessToken, param);
      if (data !== undefined) {
        data.warehouse.map((value) => {
          if (value.is_destination === true) {
            resDestination.push({
              key: `${value.warehouse_code}`,
              value: value.id,
              label: value.warehouse_code,
            });
            setDestinationName(value.warehouse_code);
          }
          if (value.is_origin === true) {
            resOrigin.push({
              key: `${value.warehouse_code}`,
              value: value.id,
              label: value.warehouse_code,
            });
            setOriginName(value.warehouse_code);
          }
        });
      }
      setSearch({ ...param });
      setDestination(resDestination);
      setOrigin(resOrigin);
      setRouteLoading(false);
    } catch (err) {
      console.error("[ModalCreateRoute] fetchCompanyWareHouseRoutes: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setRouteLoading(false);
    }
    setRouteLoading(false);
  }, []);

  useEffect(() => {
    if (!accessToken || !isModalOpen) {
      return;
    }
    setRouteLoading(true);
    const values = {
      is_active: "true",
    };
    search.page = 1;

    if (isEdit) {
      const originWh = editCustomerRoutesData.app_warehouse_app_customerroute_origin_idToapp_warehouse;
      const destWh = editCustomerRoutesData.app_warehouse_app_customerroute_destination_idToapp_warehouse;

      if (originWh) {
        const code = originWh.warehouse_code;
        formCustomerRoutes.setFieldValue("origin", code);
        setOriginName(code);
      }

      if (destWh) {
        const code = destWh.warehouse_code;
        formCustomerRoutes.setFieldValue("destination", code);
        setDestinationName(code);
      }
    } else {
      setOriginName("");
      setDestinationName("");
      formCustomerRoutes.resetFields();
    }
    fetchCompanyWareHouseRoutes({ ...search, values });
    setRouteLoading(false);
  }, [
    accessToken,
    fetchCompanyWareHouseRoutes,
    isModalOpen,
    isEdit,
    editCustomerRoutesData?.id,
    formCustomerRoutes,
  ]);

  return (
    <Spin spinning={routeLoading}>
      {contextHolder}
      <Modal
        title={
          isEdit
            ? t("Customer_Create.Create_Route.Text_Edit_Routes")
            : t("Customer_Create.Create_Route.Text_Add_Routes")
        }
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={true}
        centered={true}
        forceRender={true}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={() => (
          <>
            <Button type="primary" onClick={onSubmitRoutes} loading={routeLoading}>
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
            <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
          </>
        )}
      >
        <Col span={24}>
          <Form
            name="customerRoutesForm"
            form={formCustomerRoutes}
            labelAlign="left"
            labelCol={{
              flex: "140px",
            }}
          >
            <Form.Item
              label={t("Customer_Table.Origin") + ":"}
              name="origin"
              key="origin"
              style={{ marginBottom: "1rem" }}
              rules={originRules}
              validateTrigger={["onChange", "onBlur"]}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder={t("Customer_Create.Create_Route.Placeholder_Origin")}
                allowClear
                options={origin}
                onChange={(_value, option) => {
                  setOriginName(option?.label ?? "");
                }}
              />
            </Form.Item>
            <Form.Item
              label={t("Customer_Table.Destination") + ":"}
              name="destination"
              key="destination"
              style={{ marginBottom: "1rem" }}
              rules={destinationRules}
              validateTrigger={["onChange", "onBlur"]}
            >
              <Select
                style={{
                  width: "100%",
                }}
                placeholder={t("Customer_Create.Create_Route.Placeholder_Destination")}
                allowClear
                options={destination}
                onChange={(_value, option) => {
                  setDestinationName(option?.label ?? "");
                }}
              />
            </Form.Item>
          </Form>
        </Col>
      </Modal>
    </Spin>
  );
};
